import React from 'react';
import Button from '../components/Button';
import closeIcon from '../icons/clear.svg';
import listPostsIcon from '../icons/listPosts.svg';
import { getPreviousRoute } from '../utils/url/templatesPath';
import styles from './TemplateMobileHeader.module.scss';

interface TemplateMobileHeaderProps {
  openSidebar: () => void;
  onClose?: () => void;
}

const TemplateMobileHeader = ({
  openSidebar,
  onClose,
}: TemplateMobileHeaderProps) => {
  return (
    <div className={styles.container}>
      <Button icon={listPostsIcon} onClick={openSidebar} />
      <div className={styles.title}>Templates</div>
      <Button
        icon={closeIcon}
        onClick={onClose}
        to={onClose ? undefined : getPreviousRoute()}
      />
    </div>
  );
};

export default TemplateMobileHeader;
